import React from 'react';
import {
  NeedleDetailsContainer,
  TableContainer,
  Table,
  TableHeader,
  TableRow,
  TableData,
  CTAButton,
  FilterWrapper,
  FilterItem,
  FilterIcon,
  LinkContainer,
  CehvronContainer,
} from './styled';
import { needleRows } from './types';
import { useNavigate } from 'react-router-dom';
import TaperPointZ from '../../../../assets/TaperPointZ.png'
import TaperCuttingK from '../../../../assets/TaperCuttingK.png'
import ReverseCuttingX from '../../../../assets/ReverseCuttingX.png'
import ConventionalCuttingY from '../../../../assets/ConventionalCuttingY.png'


const filters = ['Taper Point (Z)', 'Taper Cutting (K)', 'Reverse Cutting (X)', 'Conventional Cutting (Y)'];
const ImageIcons = [TaperPointZ, TaperCuttingK, ReverseCuttingX, ConventionalCuttingY]

const NeedleDetails: React.FC = () => {
  const navigate = useNavigate();
  return (
    <NeedleDetailsContainer>
      <FilterWrapper>
        {filters.map((label, idx) => (
          <FilterItem key={idx}>
            <FilterIcon src={ImageIcons[idx]}/>
            <span>{label}</span>
          </FilterItem>
        ))}
      </FilterWrapper>
      <TableContainer>
        <Table>
          <thead>
            <TableHeader>
              <th>S. No.</th>
              <th>Curve</th>
              <th>Needle Type</th>
              <th>Needle Length</th>
              <th>Bore Diameter</th>
              <th>Wire Diameter</th>
              <th>Coating</th>
            </TableHeader>
          </thead>
          <tbody>
            {needleRows.map((row, i) => (
              <TableRow key={i} alt={i % 2 !== 0}>
                <TableData>{row.srNo}</TableData>
                <TableData>{row.curve}</TableData>
                <TableData>{row.needleType}</TableData>
                <TableData>{row.needleLength}</TableData>
                <TableData>{row.boreDiameter}</TableData>
                <TableData>{row.wireDiameter}</TableData>
                <TableData>{row.coating}</TableData>
              </TableRow>
            ))}
          </tbody>
        </Table>
      </TableContainer>
      <CTAButton onClick={() => navigate('/?scroll=contact')}>Get In touch</CTAButton>
      <LinkContainer>
            <CehvronContainer href='#header'>&#8963;</CehvronContainer>
      </LinkContainer>
    </NeedleDetailsContainer>
  );
};

export default NeedleDetails;
